export function formatSiteId(site_id: string) {
  if (site_id === 'prophetx') {
    return 'ProphetX';
  } else if (site_id === 'betonline') {
    return 'BetOnline';
  } else if (site_id === 'betmgm') {
    return 'BetMGM';
  } else if (site_id === 'draftkings') {
    return 'DraftKings';
  } else if (site_id === 'espnbet') {
    return 'ESPNBet';
  } else if (site_id === 'pointsbet') {
    return 'PointsBet';
  } else if (site_id === 'wynnbet') {
    return 'WynnBet';
  } else if (site_id === 'sisportsbook') {
    return 'SISportsbook';
  } else if (site_id === 'mvgbet') {
    return 'MVGBet';
  } else {
    return site_id.charAt(0).toUpperCase() + site_id.slice(1);
  }
}